export const COMPANY = {
  name: "Tech Thrissur",
  tagline: "Own The Best!",
  address: {
    line1: "Elavally South P.O",
    line2: "Thrissur – 680511",
    state: "Kerala, India",
  },
  gstin: "32AQQPP5208B1Z2",
  phones: ["+91 9400903060", "+91 9847711590"],
  email: "techthrissurofficial@gmail.com",
  whatsapp: "919400903060",
  logo: "/assets/tech-thrissur-logo.png",
  // Same uploaded artwork, with light lettering for dark backgrounds.
  logoDark: "/assets/tech-thrissur-logo-dark.png",
};

export const NAV_LINKS = [
  { id: "about", label: "About" },
  { id: "solutions", label: "Solutions" },
  { id: "features", label: "Why Us" },
  { id: "process", label: "Process" },
  { id: "enphase", label: "Enphase" },
  { id: "contact", label: "Contact" },
];

export const HERO_BG =
  "https://images.unsplash.com/photo-1509391366360-2e959784a276?auto=format&fit=crop&w=1920&q=80";

export const ENPHASE_IMG =
  "https://customer-assets-eiarnc6j.emergentagent.net/job_tech-thrissur-solar/artifacts/2n3qtps3_WhatsApp%20Image%202026-09-23%20at%2011.54.21%20AM.jpeg";
